<template lang="pug"></template>

<script>
export default {
    name: 'BotaoOperacoesCdaWa',
    componentOptions: {
        title: 'Operação CDA-WA',
        actions: [
            [
                {
                    name: 'Operação CDA-WA',
                    iconClass: 'lyra-icon lyra-transfer',
                    showView: false,
                    action: 'abrirOperacoesCdaWa',
                    route: 'OperacoesCdaWa'
                }
            ]
        ]
    },

    methods: {
        abrirOperacoesCdaWa() {
            if (this.$route.name !== 'OperacoesCdaWa') {
                this.$router.push({ name: 'OperacoesCdaWa' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
